// extracted by mini-css-extract-plugin
export default {"flag":"CountryOption_flag__qwlV8"};